<template>
    <div class="p-logos">
        <!-- Stripe Logo -->
        <svg
            width="49"
            height="20"
            viewBox="0 0 49 20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="m26.021 2.71-3.35.721V.708L26.02 0v2.71Zm6.97 1.509c-1.309 0-2.15.614-2.617 1.041l-.174-.827h-2.937V20l3.338-.708.013-3.778c.48.347 1.188.841 2.363.841 2.39 0 4.566-1.922 4.566-6.155-.013-3.871-2.216-5.981-4.552-5.981Zm-.801 9.199c-.788 0-1.255-.28-1.576-.628l-.013-4.953c.347-.387.828-.654 1.589-.654 1.215 0 2.056 1.362 2.056 3.11 0 1.79-.828 3.125-2.056 3.125Zm15.874-3.084c0-3.418-1.656-6.115-4.82-6.115-3.177 0-5.1 2.697-5.1 6.088 0 4.019 2.27 6.048 5.528 6.048 1.588 0 2.79-.36 3.698-.868v-2.67c-.908.454-1.95.734-3.271.734-1.295 0-2.443-.454-2.59-2.029h6.528c0-.074.005-.24.01-.433v-.002c.008-.262.017-.57.017-.753Zm-6.596-1.269c0-1.508.922-2.136 1.763-2.136.814 0 1.682.628 1.682 2.136H41.47Zm-15.447-4.62h-3.35v11.683h3.35V4.446Zm-7.156.001.214.988c.787-1.442 2.35-1.148 2.777-.988v3.07c-.414-.146-1.75-.333-2.537.695v7.917h-3.338V4.446h2.884Zm-6.462-2.897-3.258.694-.013 10.694c0 1.976 1.482 3.431 3.458 3.431 1.095 0 1.896-.2 2.337-.44v-2.71c-.428.173-2.537.787-2.537-1.189V7.29h2.537V4.447H12.39l.013-2.897Zm-7.89 5.567c-.708 0-1.135.2-1.135.721 0 .569.735.819 1.647 1.129 1.487.506 3.445 1.171 3.453 3.638 0 2.39-1.91 3.765-4.686 3.765a9.254 9.254 0 0 1-3.645-.761V12.43c1.121.614 2.537 1.068 3.645 1.068.747 0 1.281-.2 1.281-.814 0-.63-.797-.918-1.759-1.265C1.85 10.889 0 10.221 0 7.996 0 5.634 1.802 4.22 4.513 4.22c1.108 0 2.203.174 3.31.614v3.138c-1.014-.548-2.296-.855-3.31-.855Z"
                fill="#635BFF"
            />
        </svg>
        <!-- Amex Logo -->
        <svg
            width="20"
            height="20"
            viewBox="0 0 20 20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M20 12.955c0 .5-.316.734-.883.734h-1.082v-.5h1.082c.1 0 .184-.017.217-.05a.213.213 0 0 0 .067-.15.255.255 0 0 0-.067-.168c-.033-.033-.1-.05-.2-.05-.516-.017-1.166.017-1.166-.718 0-.334.217-.7.8-.7h1.115v.5h-1.032c-.1 0-.166 0-.216.033a.24.24 0 0 0-.084.184c0 .083.05.134.117.167.067.017.133.034.216.034h.3c.316 0 .517.066.65.183.1.117.166.267.166.501Zm-2.348-.5c-.133-.118-.333-.184-.65-.184h-.3c-.082 0-.15-.017-.216-.034-.066-.033-.116-.084-.116-.167 0-.084.016-.133.083-.184.05-.033.117-.033.216-.033h1.033v-.5h-1.116c-.6 0-.8.366-.8.7 0 .735.65.701 1.167.718.1 0 .166.017.2.05.033.034.066.1.066.167a.213.213 0 0 1-.067.15.377.377 0 0 1-.216.05h-1.083v.501h1.083c.566 0 .882-.233.882-.734 0-.234-.066-.384-.166-.5Zm-2.132.75h-1.315v-.467h1.282v-.467h-1.282v-.435h1.315v-.484h-1.865v2.338h1.865v-.484Zm-2.464-1.736c-.183-.1-.4-.117-.683-.117h-1.282v2.337h.566v-.85h.6c.2 0 .316.016.4.1.1.116.1.316.1.467v.283h.549v-.45c0-.217-.017-.318-.084-.434a.649.649 0 0 0-.282-.2c.15-.05.4-.251.4-.619-.001-.266-.101-.417-.284-.517Zm-3.164-.117H8.11l-.716.768-.683-.768H4.463v2.337h2.215l.716-.768.683.768h1.082v-.784h.7c.482 0 .966-.134.966-.785 0-.634-.5-.768-.933-.768Zm2.714.969c-.083.033-.166.033-.266.033l-.683.017v-.535h.683c.1 0 .2 0 .266.05.067.034.117.1.117.2 0 .101-.05.185-.117.235Zm-2.714.117h-.733v-.602h.733c.2 0 .333.084.333.284 0 .2-.133.318-.333.318Zm-2.148.083.865-.918v1.886l-.865-.968Zm-1.35.684H5.013v-.467h1.233v-.467H5.012v-.435h1.4l.616.685-.633.684Zm12.057-3.539h-.799l-1.05-1.753v1.753h-1.131l-.217-.517h-1.166l-.216.517h-.65c-.266 0-.616-.067-.816-.267-.183-.2-.283-.467-.283-.885 0-.35.05-.668.3-.918.166-.184.466-.267.85-.267h.532v.5h-.533c-.2 0-.316.034-.433.134-.1.1-.15.284-.15.535 0 .25.05.434.15.55.083.084.233.117.383.117h.25l.8-1.836h.832l.933 2.204V7.329h.866l.982 1.62v-1.62h.566v2.337Zm-6.61-2.337h-.567v2.337h.566V7.33Zm-1.183.1c-.183-.1-.383-.1-.666-.1H8.709v2.337h.55v-.851h.6c.2 0 .332.016.416.1.1.117.083.317.083.45v.301h.566V9.2c0-.2-.017-.3-.1-.418a.697.697 0 0 0-.266-.2c.15-.067.4-.25.4-.618 0-.267-.117-.417-.3-.534ZM8.31 9.182h-1.3v-.467h1.283V8.23H7.011v-.418H8.31V7.33H6.445v2.337H8.31v-.484ZM6.028 7.33h-.916L4.43 8.915l-.733-1.586h-.9v2.204l-.949-2.204h-.832l-1 2.337h.6l.217-.517h1.165l.217.517h1.132V7.83l.816 1.836h.483l.816-1.836v1.836h.566V7.33Zm9.026 1.319-.383-.918-.383.918h.766Zm-4.83-.367c-.082.05-.166.05-.282.05h-.683v-.518h.683c.1 0 .216 0 .283.034.066.05.1.117.1.217 0 .1-.034.183-.1.217Zm-9.192.367.383-.918.383.918h-.766ZM19.867 0H0v8.414l.683-1.552H2.13l.2.383v-.383H4.03l.383.834.366-.834h5.412c.25 0 .467.05.633.183v-.183h1.482v.183c.25-.133.566-.183.933-.183h2.148l.2.383v-.383h1.582l.233.383v-.383h1.549v3.272h-1.566l-.3-.501v.5h-1.948l-.216-.534h-.483l-.216.535h-1.016c-.4 0-.7-.1-.9-.2v.2H9.893v-.752c0-.1-.017-.117-.083-.117h-.084v.868H5.062v-.417l-.166.418h-.982l-.167-.401v.4H1.865l-.2-.534h-.483l-.216.534H0V20h19.867v-5.993c-.217.1-.516.15-.816.15h-1.449v-.2c-.166.133-.466.2-.75.2H12.29v-.751c0-.1-.017-.1-.1-.1h-.083v.85h-1.5v-.884c-.249.117-.532.117-.782.117H9.66v.768H7.827l-.433-.501-.483.5H3.963v-3.271h2.998l.433.5.466-.5h2.015c.233 0 .616.033.783.2v-.2h1.798c.183 0 .533.033.766.2v-.2h2.715v.2c.15-.133.433-.2.682-.2h1.516v.2c.167-.117.4-.2.7-.2h1.032V0Z"
                fill="#006FCF"
            />
        </svg>
        <!-- Mastercard Logo -->
        <svg
            width="33"
            height="20"
            viewBox="0 0 33 20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M20.554 17.861h-8.75V2.138h8.75V17.86Z"
                fill="#FF5F00"
            />
            <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M12.36 10c0-3.19 1.493-6.03 3.818-7.862A9.958 9.958 0 0 0 9.998 0C4.477 0 0 4.477 0 10s4.476 10 9.999 10a9.959 9.959 0 0 0 6.18-2.138A9.983 9.983 0 0 1 12.358 10Z"
                fill="#EB001B"
            />
            <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M32.358 10c0 5.523-4.477 10-10 10a9.961 9.961 0 0 1-6.18-2.138A9.982 9.982 0 0 0 19.999 10c0-3.19-1.493-6.03-3.82-7.862A9.96 9.96 0 0 1 22.359 0c5.523 0 10 4.477 10 10"
                fill="#F79410"
            />
        </svg>
        <!-- Maestro Logo -->
        <svg
            width="33"
            height="20"
            viewBox="0 0 33 20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M11.799 2.14h8.749v15.723h-8.75V2.139Z"
                fill="#6C6BBD"
            />
            <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M12.36 10a9.983 9.983 0 0 1 3.819-7.862A9.957 9.957 0 0 0 9.998 0C4.476 0 0 4.477 0 10s4.476 10 9.999 10c2.332 0 4.479-.8 6.18-2.138A9.983 9.983 0 0 1 12.358 10Z"
                fill="#EB001B"
            />
            <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M32.348 10c0 5.523-4.476 10-9.999 10a9.96 9.96 0 0 1-6.18-2.138A9.982 9.982 0 0 0 19.989 10a9.982 9.982 0 0 0-3.82-7.862A9.96 9.96 0 0 1 22.349 0c5.523 0 9.999 4.477 9.999 10Z"
                fill="#0099DF"
            />
        </svg>
        <!-- Visa Logo -->
        <svg
            width="43"
            height="14"
            viewBox="0 0 43 14"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M22.238 4.476c-.024 1.95 1.724 3.038 3.041 3.685 1.354.664 1.808 1.09 1.803 1.684-.01.908-1.08 1.31-2.08 1.325-1.746.027-2.76-.475-3.568-.855l-.629 2.966c.81.377 2.309.705 3.864.719 3.649 0 6.036-1.816 6.049-4.632.014-3.573-4.903-3.771-4.87-5.369.012-.484.47-1 1.475-1.132.497-.067 1.87-.118 3.426.605l.61-2.87A9.244 9.244 0 0 0 28.11 0c-3.435 0-5.851 1.84-5.87 4.476ZM37.228.247c-.666 0-1.228.392-1.478.994l-5.213 12.548h3.647l.725-2.022h4.456l.421 2.022H43L40.195.247h-2.967Zm.51 3.659 1.053 5.084h-2.882l1.83-5.084ZM17.818.247 14.942 13.79h3.475L21.29.247h-3.474Zm-5.14 0L9.06 9.464 7.597 1.627C7.426.753 6.747.247 5.995.247H.083L0 .641c1.214.265 2.593.693 3.428 1.152.511.28.657.524.825 1.19l2.771 10.806h3.673L16.326.247h-3.65Z"
                fill="#1A1F71"
            />
        </svg>
    </div>
</template>

<style lang="scss" scoped>
@import '@/assets/css/theme.scss';
@import '@/assets/css/variables.scss';

.p-logos {
    @include container;
    @include flex;
    @include items-center;
    @include justify-between;
    @include ph-24;
    @include pv-16;
}
</style>
